<template>
  <EditContactsPage
    :get-gql-query="getGqlQuery"
    :get-query-variables="getQueryVariables"
    :update-query-variable="updateQueryVariable"
  />
</template>

<script>
import EditContactsPage from '@/pages/Contact/EditContactsPage'
import QUERY_CONTACT_TO_EDIT from '@/backend/graphql/contact/ContactToEdit.gql'
export default {
  name: 'EditContactPage',
  components: {
    EditContactsPage
  },
  data: function () {
    return {
      getGqlQuery: QUERY_CONTACT_TO_EDIT,
      limit: 50,
      offset: 0,
      orderBy: '-profile__id,-profile__last_recv_at',
      contactId: 0,
      idDelete: 0
    }
  },
  created () {
    this.contactId = this.$route.params.contactId
  },
  methods: {
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        id: this.contactId,
        isDelete: this.idDelete
      }
    },
    updateQueryVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    }
  }
}
</script>

<style scoped>

</style>
